import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productFields } from './common/productFields';
import {
  buildingCommonFields,
  buildingRevisionFields,
} from './common/buildingCommonFields';
import { coordinateFields } from './common/coordinateFields';
import { msg } from '@lingui/core/macro';
import { volumeUnitField } from './common/sharedFields';
import { utilityCostFields } from './common/utilityCostFields';

export const waterDischargeMetadata = {
  displayName: msg({
    message: 'Water discharge',
    context: 'Activity data schema name for water discharge',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    ...buildingCommonFields,
    ...coordinateFields,
    ...buildingRevisionFields,
    ...utilityCostFields,
    quantity: {
      displayName: msg({
        message: 'Water discharge',
        context: 'The quantity of water discharged.',
      }),
      externalDescription: msg({
        message:
          'The quantity of water discharged from organizational boundaries to surface water, groundwater, or third parties like wastewater treatment plants.',
        context: 'Water discharged',
      }),
    },
    unit: volumeUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
